import type { Module } from "vuex";
import { services } from "./mockData/services";

interface Service {
  id: number;
  name: string;
  time: string;
  pricePln: string;
  priceStartsFrom: boolean;
}

interface ServiceStore {
  services: Service[];
}

const module: Module<ServiceStore, unknown> = {
  namespaced: true,
  state: {
    services,
  },
  mutations: {
    addService(state, newValue: Service) {
      newValue.id = state.services.length;
      state.services.push(newValue);
    },
    editService(state, newValue: Service) {
      const editedIdx = state.services.findIndex((x) => {
        return x.id === newValue.id;
      });
      if (!state.services[editedIdx]) return;

      state.services[editedIdx] = newValue;
    },
    deleteService(state, id: number) {
      state.services = state.services.filter((x) => x.id !== id);
    },
  },
};

export default module;
